var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; // Vendors


import React from 'react';
import classnames from 'classnames'; // Styles

import './icon.scss';
import { default as AlertDanger } from '../../assets/icons/AlertDanger';
import { default as AlertInfo } from '../../assets/icons/AlertInfo';
import { default as AlertSuccess } from '../../assets/icons/AlertSuccess';
import { default as AlertWarning } from '../../assets/icons/AlertWarning';
import { default as Bell } from '../../assets/icons/Bell';
import { default as Check } from '../../assets/icons/Check';
import { default as ChevronDown } from '../../assets/icons/ChevronDown';
import { default as ChevronLeft } from '../../assets/icons/ChevronLeft';
import { default as ChevronRight } from '../../assets/icons/ChevronRight';
import { default as ChevronUp } from '../../assets/icons/ChevronUp';
import { default as CreditCard } from '../../assets/icons/CreditCard';
import { default as Download } from '../../assets/icons/Download';
import { default as Edit } from '../../assets/icons/Edit';
import { default as Exclamation } from '../../assets/icons/Exclamation';
import { default as ExternalLink } from '../../assets/icons/ExternalLink';
import { default as Eye } from '../../assets/icons/Eye';
import { default as EyeClosed } from '../../assets/icons/EyeClosed';
import { default as Hamburger } from '../../assets/icons/Hamburger';
import { default as Info } from '../../assets/icons/Info';
import { default as Link } from '../../assets/icons/Link';
import { default as List } from '../../assets/icons/List';
import { default as Lock } from '../../assets/icons/Lock';
import { default as LoneStar } from '../../assets/icons/LoneStar';
import { default as Mail } from '../../assets/icons/Mail';
import { default as MessageSquare } from '../../assets/icons/MessageSquare';
import { default as More } from '../../assets/icons/More';
import { default as Phone } from '../../assets/icons/Phone';
import { default as Plus } from '../../assets/icons/Plus';
import { default as PlusCircle } from '../../assets/icons/PlusCircle';
import { default as Repeat } from '../../assets/icons/Repeat';
import { default as Search } from '../../assets/icons/Search';
import { default as Shield } from '../../assets/icons/Shield';
import { default as Star } from '../../assets/icons/Star';
import { default as User } from '../../assets/icons/User';
import { default as Wallet } from '../../assets/icons/Wallet';
import { default as X } from '../../assets/icons/X';
export var icons = {
  'alert-danger': AlertDanger,
  'alert-info': AlertInfo,
  'alert-success': AlertSuccess,
  'alert-warning': AlertWarning,
  bell: Bell,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUp,
  'credit-card': CreditCard,
  download: Download,
  edit: Edit,
  exclamation: Exclamation,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-closed': EyeClosed,
  hamburger: Hamburger,
  info: Info,
  link: Link,
  list: List,
  lock: Lock,
  'lone-star': LoneStar,
  mail: Mail,
  'message-square': MessageSquare,
  more: More,
  phone: Phone,
  plus: Plus,
  'plus-circle': PlusCircle,
  repeat: Repeat,
  search: Search,
  shield: Shield,
  star: Star,
  user: User,
  wallet: Wallet,
  x: X
};
/**
 * @visibleName Default
 */

export function Icon(_a) {
  var name = _a.name,
      className = _a.className,
      props = __rest(_a, ["name", "className"]);

  if (!name || !icons[name]) return React.createElement(React.Fragment, null);
  var Icon = icons[name];
  return React.createElement("span", __assign({}, props, {
    className: classnames("icon icon-" + name, className)
  }), React.createElement(Icon, {
    role: "presentation"
  }));
}